import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'

const Locator = () => (
  <Layout>
    <SEO title="Terms of Service" />
    <div class="banner">
      <div class="container">
        <div class="colx1">
          <div class="copy">
            <h3 class="center">
            Terms of Service and Privacy Policy
            </h3>
            <a class="btn_alt" href="#"><i className="fa fa-angle-down"></i></a>
          </div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="container">
        <div class="colx1">
        <div class="left">
        <h2>Terms of Service</h2>
        <h4>1. Terms</h4>
        
          <p>By accessing the website at&nbsp;<a href="http://www.zpharm.ca">http://www.zpharm.ca</a>, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.</p>
        
        <h4>2. Use License</h4>
        
          <ol type="a">
            <li>
              <p>Permission is granted to temporarily download one copy of the materials (information or software) on zpharm's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
        
              <ol type="i">
                <li><p>modify or copy the materials;</p></li>
                <li><p>use the materials for any commercial purpose, or for any public display (commercial or non-commercial);</p></li>
                <li><p>attempt to decompile or reverse engineer any software contained on zpharm's website;</p></li>
                <li><p>remove any copyright or other proprietary notations from the materials; or</p></li>
                <li><p>transfer the materials to another person or "mirror" the materials on any other server.</p></li>
              </ol>
            </li>
            <li><p>This license shall automatically terminate if you violate any of these restrictions and may be terminated by zpharm at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p></li>
          </ol>
        
        <h4>3. Disclaimer</h4>
        
          <ol type="a">
            <li><p>The materials on zpharm's website are provided on an 'as is' basis. zpharm makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p></li>
            <li><p>Further, zpharm does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</p></li>
          </ol>
        
        <h4>4. Limitations</h4>
        
          <p>In no event shall zpharm or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on zpharm's website, even if zpharm or a zpharm authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.</p>
        
        <h4>5. Accuracy of materials</h4>
        
          <p>The materials appearing on zpharm's website could include technical, typographical, or photographic errors. zpharm does not warrant that any of the materials on its website are accurate, complete or current. zpharm may make changes to the materials contained on its website at any time without notice. However zpharm does not make any commitment to update the materials.</p>
        
        <h4>6. Links</h4>
        
          <p>zpharm has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by zpharm of the site. Use of any such linked website is at the user's own risk.</p>
        
        <h4>7. Modifications</h4>
        
          <p>zpharm may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
        
        <h4>8. Governing Law</h4>
        
          <p>These terms and conditions are governed by and construed in accordance with the laws of Waterloo, Ontario and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
        
        <br/><br/><br/>
        <h2>Privacy Policy</h2>
        
          <p>Your privacy is important to us.</p>
          <br/>
          <p>It is zpharm's policy to respect your privacy regarding any information we may collect while operating our website. Accordingly, we have developed this privacy policy in order for you to understand how we collect, use, communicate, disclose and otherwise make use of personal information. We have outlined our privacy policy below.</p>
          <br/>
          <ul>
            <li><p>We will collect personal information by lawful and fair means and, where appropriate, with the knowledge or consent of the individual concerned.</p></li>
            <br/>
            <li><p>Before or at the time of collecting personal information, we will identify the purposes for which information is being collected.</p></li>
            <br/>
            <li><p>We will collect and use personal information solely for fulfilling those purposes specified by us and for other ancillary purposes, unless we obtain the consent of the individual concerned or as required by law.</p></li>
            <br/>
            <li><p>Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary for those purposes, should be accurate, complete, and up-to-date.</p></li>
            <br/>
            <li><p>We will protect personal information by using reasonable security safeguards against loss or theft, as well as unauthorized access, disclosure, copying, use or modification.</p></li>
            <br/>
            <li><p>We will make readily available to customers information about our policies and practices relating to the management of personal information.</p></li>
            <br/>
            <li><p>We will only retain personal information for as long as necessary for the fulfilment of those purposes.</p></li>
          </ul>
          <br/>
          <p>We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained. zpharm may change this privacy policy from time to time at zpharm's sole discretion.</p>
        
        </div>
        
        </div>
      </div>
    </div>
  </Layout>
)

export default Locator
